import React from "react";
import Image, { type ImageProps } from "next/image";

/**
 * A Next image that fills the entire space of the container.
 */
export function FillImage(props: ImageProps) {
  return <Image fill sizes="100%" placeholder="blur" {...props} />;
}

/**
 * A Next image that fills the entire space of the container, intended for use with
 * purely decorative images (e.g. background photography on case studies) as it will
 * omit them from accessibility APIs by applying `aria-hidden`.
 *
 * By default, the image will cover the whole container and be centered.
 */
export function DecorativeBackgroundImage(props: Omit<ImageProps, "alt">) {
  return (
    <Image
      fill
      sizes="100%"
      aria-hidden="true"
      alt=""
      style={{ objectFit: "cover", objectPosition: "center" }}
      {...props}
    />
  );
}
